<template>
  <div class="md-layout news-layout">
    <div class="md-layout-item md-size-100 mobile-layout">
      <md-card class="mobile-card news-card">
        <md-card-content class="mobile-content">
          <div class="news-page-wrapper">
            <div class="news-tab-wrapper">
              <news-tab-bar v-model="active" />
            </div>
            <div v-if="list.length > 0">
              <router-link
                class="news-item"
                v-for="news in list"
                :key="news.id"
                :to="{
                  name: 'NewsDetailPage',
                  params: {
                    postId: news.id,
                    manageOrganizationId: moId,
                    newsType: active === 'News' ? 'Новость' : 'Объявление'
                  }
                }"
              >
                <span class="md-theme-list-head-color news-item__title">
                  {{ news.title }}
                </span>
                <div class="text-grey-1 news-item__date">{{ news.date }}</div>
                <p class="text-main-black news-item__descr">
                  {{ news.content }}
                </p>
              </router-link>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NewsTabBar from '@/apps/news/components/NewsTabBar';

export default {
  name: "NewsPage",
  components: {
    NewsTabBar,
  },
  data() {
    return {
      active: 'News'
    };
  },
  computed: {
    ...mapGetters(['getNewsCompany', 'getNewsHome', 'getManageOrganizationInfo']),

    list() {
      return this.active === 'News' ? this.getNewsCompany : this.getNewsHome;
    },

    moId() {
      return this.getManageOrganizationInfo.id || null
    }
  },
};
</script>

<style lang="scss" scoped>
.news-layout {
  @media (max-width: 768px) {
    background-color: #ffffff;
  }
}
.news-card {
  max-width: 785px;
  @media (max-width: 768px) {
    box-shadow: unset;
  }
  .md-card-content {
    padding: 25px 20px;
  }
  .news-page-wrapper {
    padding: 0 10px;
  }
  .news-item {
    display: flex;
    flex-direction: column;
    padding-top: 15px;
    &:not(:last-child) {
      border-bottom: 1px solid #eee;
    }
    &:hover {
      background-color: #f5f5f5;
    }
    &__title {
      order: 1;
      font-weight: 700;
      letter-spacing: 1px;
    }
    &__descr {
      order: 3;
      line-height: 22px;
      margin: 0 0 15px 0;
    }
    &__date {
      order: 2;
      font-size: 12px;
      @media (max-width: 768px) {
        order: 0;
      }
    }
  }
}
</style>
